import * as classnames from 'classnames/bind'
import * as React from 'react'
import { connect } from 'react-redux'
import logo from 'src/images/common/brand/avatar.svg'
import { text2Html } from 'src/utils'
import { dispatch, RootState, select, store } from '../../store'

import avaterStyles from './../../components/Avatar/avatar.scss'
import styles from './lecture-teachers.scss'

const cx = classnames.bind({ ...avaterStyles, ...styles })

interface IProps extends React.HTMLProps<HTMLDivElement> {
  editable?: boolean
  userId?: string
  information: {
    description: string;
    title: string;
  }
}
class TeacherComponent extends React.PureComponent<IProps> {
  public state = {
    error: null
  }
  public fetchData = (props: IProps) => {
    const rootState = store.getState()
    const { userId } = props
    const user = select.users.getById(rootState, userId)
    if (userId && user === null) {
      dispatch.users.fetchUsers([userId])
    }
  }

  public componentWillReceiveProps = (nextProps: IProps) => {
    if (nextProps.userId !== this.props.userId) {
      this.fetchData(nextProps)
    }
  }
  public componentDidMount = () => {
    this.fetchData(this.props)
  }
  public render() {
    const { className, userId, information } = this.props
    const rootState = store.getState()
    const user = select.users.getById(rootState, userId)
    const style = {
      backgroundImage:
        user && user.photoURL ? `url('${user.photoURL}')` : `url('${logo}')`
    }
    if (user) {
      return (
        <div className={cx('teacher_card')}>
          <div className={cx('teacher_card_left')}>
            {/* <div className={cx('teacher_card_avatar')} style={{ backgroundImage: `url('')` }} /> */}
            <div className={cx('avatar', className)} style={style} />
          </div>
          <div className={cx('teacher_card_right')}>
            <h3>{user.fullName}</h3>
            <h4>{information ? information.title : ''}</h4>
            <p
              dangerouslySetInnerHTML={{
                __html: information ? text2Html(information.description) : ''
              }}
            />
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}

const mapState = ({ users }: RootState) => ({ users })
export default connect(mapState)(TeacherComponent)



// WEBPACK FOOTER //
// ./src/pages/LecturePage/lecture-teacher-component.tsx